import React, { ReactElement, useRef, useMemo } from 'react';
import { Box } from '@mui/material';
import { useWordDocument } from 'hooks/useFileType/useWordDocument';
import {
  WORD_THUMBNAIL_ALLOWED_ATTR,
  WORD_THUMBNAIL_ALLOWED_TAGS,
  WORD_THUMBNAIL_STYLE_MAP,
} from '../../../../app/constants/wordSanitization';
import {
  ThumbnailErrorFallback,
  ThumbnailLoadingOverlay,
} from './common';
import {
  getWordThumbnailContentSx,
  THUMBNAIL_CONTAINER_SX,
} from './styles';
import { ThumbnailProps } from './types';

export const WordThumbnail: React.FC<ThumbnailProps> = ({
  src,
  thumbnailSize,
  onClick,
  fileType,
  fileExtension,
}): ReactElement => {
  const containerRef = useRef<HTMLDivElement>(null);

  const wordOptions = useMemo(
    () => ({
      styleMap: [...WORD_THUMBNAIL_STYLE_MAP],
      allowedTags: [...WORD_THUMBNAIL_ALLOWED_TAGS],
      allowedAttr: [...WORD_THUMBNAIL_ALLOWED_ATTR],
    }),
    []
  );

  const { loading, error, htmlContent } = useWordDocument(
    src,
    wordOptions
  );

  const contentSx = useMemo(
    () => getWordThumbnailContentSx(loading),
    [loading]
  );

  if (error) {
    return (
      <ThumbnailErrorFallback
        onClick={onClick}
        fileType={fileType}
        fileExtension={fileExtension}
      />
    );
  }

  return (
    <Box onClick={onClick} sx={THUMBNAIL_CONTAINER_SX}>
      {loading && <ThumbnailLoadingOverlay />}
      <Box
        ref={containerRef}
        sx={contentSx}
        dangerouslySetInnerHTML={{ __html: htmlContent }}
      />
    </Box>
  );
};
